/*
* @Author: chillylight
* @Date:   2020-04-17 15:02:35
* @Last Modified by:   chillylight
* @Last Modified time: 2020-11-09 17:21:21
*/
import 'select2/dist/css/select2.min.css';
import _comMeds from '@src/assets/js/common.js';
import _tran from '@src/assets/js/server/tran-server.js';
import 'jquery-form';
import '@src/assets/js/table.js';
import '../index.scss';
import './index.scss';
import "@src/assets/css/com-trans.scss";
import 'select2';
import FormData from 'form-data';
import md5 from 'md5';
import Clipboard from "clipboard";
import _allPayBox from '@src/assets/js/totalUse/allPayBox.js';
import _humanTrans from '../../../assets/js/server/humanTrans-server';
import _headMask from "@src/assets/js/server/head-mask.js"
import _activity from '@src/assets/js/server/activity-server.js';
import "@src/assets/css/global-coupon.scss";
import '@src/assets/js/com-tran-bottom.js';
require("@src/assets/js/totalUse/tran-nav.js");
require("@src/assets/js/tran-banner.js");

var page = {
    data : {
        historyArr:localStorage.getItem("tranHistory")?JSON.parse(localStorage.getItem("tranHistory")):[],
        fromLan:'auto',
        toLan:'en',
        totalLan:[],
        toLang:'',
        checkText:'',
        type: 1,
    },
    init : function(){
        this.onLoad();
        this.bindEvent();
    },
    onLoad : function(){
        // 隐藏tab栏的翻译记录入口
        $(".tran-record-doc").hide();
        $(".tran-ad-box").hide()
        this.historyItem();
        this.lanInit();
        this.isFristCome();

        // 获取会话存储中是否有译文和原文
        // let yuanwen = sessionStorage.getItem('yuanwen')
        // let yiwen = sessionStorage.getItem('yiwen')
        // if(yuanwen && yiwen){
        //     $("#yuanwen").val(yuanwen)
        //     $("#yiwen").text(yiwen)
        // }
        var text = document.getElementById("yuanwen");
        // this.setTextAreaHeight(text,80, 200);
        _comMeds.globalCouponAlert()
    },
    bindEvent : function(){
    	var _this = this,flag = true, isClick = false;

        _comMeds.countLink(338,81);
        $(window).on('beforeunload', function () {  
            _comMeds.countLink(337,81);
        })

        // 点击复制按钮
        var clipboard = new Clipboard('#copyYiwen');
        clipboard.on('success', function(e){
            _comMeds.toastAlert('已复制');
        })

        // 删除自动翻译
        // 输入框输入内容时查询
        $('#yuanwen').on('compositionstart',function(){
            flag = false;
        })
        $('#yuanwen').on('compositionend',function(){
            flag = true;
        })
        $("#yuanwen").on("input propertychange",function(e){
            console.log(_this.data.fromLan, _this.data.toLan);
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function(){
                if (flag) {
                    let yuanwen = $("#yuanwen").val().trim();
                    $(".text-length").text(yuanwen.length+'/2000');
                    if (yuanwen.length >= 2000) {
                        $("#yuanwen").val(yuanwen.substring(0, 2000));
                        $(".text-length").css("color","#f00");
                    }else{
                        $(".text-length").removeAttr("style");
                    }
                    if (yuanwen) {
                        $(".history-div").hide();
                        $(".clear-text").show();
                        let from_lan = _this.data.fromLan;
                        let to_lan = _this.data.toLan;
                        console.log("原语言："+from_lan,"目标语言"+to_lan);

                        _this.useWhichTran(from_lan,to_lan,yuanwen);
                        $(".copy-text").show();
                    }else{
                        $(".clear-text").hide();
                        _this.emptyContentInit();
                    }
                } 
            },1500)
        })
        $("body").on('click','.trans_btn',function(e){
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function(){
                if (flag) {
                    let yuanwen = $("#yuanwen").val().trim();
                    $(".text-length").text(yuanwen.length+'/2000');
                    if (yuanwen.length >= 2000) {
                        $("#yuanwen").val(yuanwen.substring(0, 2000));
                        $(".text-length").css("color","#f00");
                    }else{
                        $(".text-length").removeAttr("style");
                    }
                    if (yuanwen) {
                        $(".history-div").hide();
                        //  $(".history-div").css('visibility','hidden')
                        $(".clear-text").show();
                        let from_lan = _this.data.fromLan;
                        let to_lan = _this.data.toLan;
                        console.log("原语言："+from_lan,"目标语言"+to_lan);

                        _this.useWhichTran(from_lan,to_lan,yuanwen);
                        $(".copy-text").show();
                    }else{
                        $(".clear-text").hide();
                        _this.emptyContentInit();
                    }
                } 
            },500)
        })

        // 清除历史记录
        $(".history-div .clear-all").click(function(){
            localStorage.removeItem("tranHistory");
            _this.data.historyArr = [];
            $(".empty-content").show();
            $(".history-content").empty().hide();
            $(".history-div .clear-all").hide();
        })

        // 点击更多语言
        $(".show-more-lan").click(function(e){
            console.log('显示更多');
            $(".search-box input").val('');
            $(".lan-table").show();
            $(".search-table").hide();
            $(".letter-index-ol").show();
            $(".often-use-lan").show();

            let type = $(this).attr("data-type");
            _this.data.type = type;
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(".total-lan-box").hide();
                $('.lang-box .icondown').removeClass('active')
                $(this).parents(".wrap").removeClass("active");
            }else{
                if ($(".total-lan-box").is(":visible")) {
                    $(".total-lan-box").hide();
                    $('.lang-box .icondown').removeClass('active')
                    $(".top-lan-box .wrap").removeClass("active");
                    $(".show-more-lan").removeClass("active");
                }else{
                    // 如果点击的是目标语言，需要将自动检测隐藏
                    if(type == 1) {
                        $(".total-lan-box .often-uselan-box .often-use-lan .often-tit").hide()
                        $(".total-lan-box .often-uselan-box .often-use-lan .auto").show()
                    } else {
                        $(".total-lan-box .often-uselan-box .often-use-lan .often-tit").show()
                        $(".total-lan-box .often-uselan-box .often-use-lan .auto").hide()
                    }
                    $(this).addClass("active");
                    $(".total-lan-box").show();
                    console.log($('.lang-box .icondown').eq(type - 1));
                    $('.lang-box .icondown').eq(type - 1).addClass('active')
                    $(this).parents(".wrap").addClass("active");
                }
            }
            // 获取父元素的type值
            // let type = $(this).parents(".wrap").attr("data-type");
            
            e.stopPropagation();
            e.preventDefault();
        })
        // 点击顶部常用语言
        $(".often-lan").click(function(){
            console.log('点击顶部常用语言');
            // let lan = $(this).attr("data-lan");
            // let type = $(this).parents(".wrap").attr("data-type");
            // let drt = $(this).attr("data-drt");
            // if (!drt) {
            //     drt = 0;
            // }
            // let lan_text = $(this).text();
            // let from = $(this).attr("data-lan");
            // let that = $(this);
            // // vip语言处理
            // console.log(lan_text, from,drt, type,'click');
            // $.each(_this.data.totalLan, function(i,item){
            //     if(item.vip == 1 && item.languageCode == lan){
            //         if(!_comMeds.isLogin()){
            //             _comMeds.doLogin();
            //         } else {
            //             if(JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
            //                 _this.vipPayTipBox(function(){
            //                     that.addClass("active").siblings().removeClass("active");
            //                    _this.ofenLangClick(lan_text, from,drt, type);
            //                 })
            //                 return false;
            //             } else {
            //                 that.addClass("active").siblings().removeClass("active");
            //                _this.ofenLangClick(lan_text, from,drt, type)
            //             }
            //         }
            //     } else {
            //         if(item.languageCode == lan ){
            //            that.addClass("active").siblings().removeClass("active");
            //            _this.ofenLangClick(lan_text, from,drt, type)
            //         }
            //     }
            // }) 

        })

        // 搜索语言
        $(".search-box input").on('input',function(){
            let lan = [];
            if(_this.data.type == 1){
                lan = _this.data.totalLan
            } else {
                lan = _this.data.toLang
            }
            let search_val = $(this).val();
            let reg = /^[a-zA-Z]+$/g;
            let result,search_item = '';
            
            if (search_val != '') {
                // 判断输入的是字母还是中文
                if (reg.test(search_val)) {
                    result = lan.filter(function(value) {
                        return value.firstLetter.match(search_val);
                    });
                }else{
                    result = lan.filter(function(value) {
                        return value.languageName.match(search_val);
                    });
                }
                $(".often-use-lan").hide();
                $(".lan-table").hide();
                $(".letter-index-ol").hide();
                if (result.length > 0) {
                    $.each(result,(i,item)=>{
                        search_item += `<p class="lang-item" data-code="${item.languageCode}" data-drt="${item.direction}">${item.languageName}</p>`;
                    })
                    $(".search-table").empty().append(search_item).show();
                }else{
                    let empty_str = '<p class="empty-lan">未找到相关语言</p>';
                    $(".search-table").empty().append(empty_str).show();
                }
            }else{
                $(".often-use-lan").show();
                $(".lan-table").show();
                $(".letter-index-ol").show();
                $(".search-table").hide();
            }            
        })
        // 点击字母索引
        $("body").on('click','.letter-index',function(e){
            let letter = $(this).text().toLowerCase();
            let top = $(".letter-block-"+letter+"").offset().top;
            let init_top = $(".letter-block-a").offset().top;
            let diff = top - init_top;
            $(".lan-table").scrollTop(diff);
        })
        // 点击弹窗中的语言
        $("body").on('click','.lang-item',function(e){
            let code = $(this).attr("data-code");
            let lanName = $(this).text();
            let drt = $(this).attr("data-drt");
            let vip = $(this).attr("data-vip");
            let type = $(".top-lan-box .wrap.active").attr("data-type");
            if (!drt) {
                drt = 0;
            }
            if(vip == 1){
                if(_comMeds.isLogin()){
                  if(JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
                     _this.vipPayTipBox(function(){
                        _this.lanOperate(code, lanName, drt, type);
                     })
                     return false;
                  }
                } else {
                  _comMeds.doLogin();
                }
            }
            _this.lanOperate(code, lanName, drt, type);

            // * 判断原文中是否有内容，如果有的话直接走翻译
            let yuanwen = $("#yuanwen").val();
            if(yuanwen) {
                $("#yuanwen").trigger('input');
            }
        })
        // 点击对换语言
        $(".toggle-lan").click(function(){
            let from = $(".lan-left li.active").attr("data-lan");
            let to = $(".lan-right li.active").attr("data-lan");
            let from_text = $(".lan-left li.active").text();
            let to_text = $(".lan-right li.active").text();
            let from_drt = $(".lan-left li.active").attr("data-drt");
            let to_drt = $(".lan-right li.active").attr("data-drt");
            if (!from_drt) {
                from_drt = 0;
            }
            if (!to_drt) {
                to_drt = 0;
            }
            if (from == 'auto') {
                return false;
            }
            let from_item = {
                languageCode:from,
                languageName:from_text,
                direction:from_drt
            };
            let to_item = {
                languageCode:to,
                languageName:to_text,
                direction:to_drt
            };

            // 对换链接中的语言
            _this.getTranParams(1,to);
            _this.getTranParams(2,from);

            let oftenUseFrom = JSON.parse(localStorage.getItem("oftenUseFrom"));
            let oftenUseTo = JSON.parse(localStorage.getItem("oftenUseTo"));

            let new_arr = _this.changeArrList(oftenUseFrom,to_item);
            localStorage.setItem("oftenUseFrom",JSON.stringify(new_arr));
            let new_arr2 = _this.changeArrList(oftenUseTo,from_item);
            localStorage.setItem("oftenUseTo",JSON.stringify(new_arr2));
            _this.afterChangeLan();
        })
        // 点击我知道了移除提示
        $(".i-know").click(function(){
            $(this).parents(".tip-box").remove();
        })
        // 点击收起
        $("body").on("click",".hide-more",function(e){
            /*var slideHeight = 200; // px 定义折叠的最小高度
            var defHeight = $('.ciyu-info').height();
            if (defHeight > slideHeight) {
                $('.ciyu-info').animate({
                    height: slideHeight
                }, "normal");
                $('.hide-more').html('展开<i class="iconfont icondown"></i>');
            }else{
                var auto_h = $('.ciyu-info').css("height","auto").height();
                $('.ciyu-info').animate({
                    height: auto_h
                }, "normal");
                $('.hide-more').html('收起<i class="iconfont iconup"></i>');
            }*/
            if ($(".ciyu-info").hasClass("active")) {
                $('.ciyu-info').removeClass("active");
                $('.hide-more').html('展开<i class="iconfont icondown"></i>');
            }else{
                $('.ciyu-info').addClass("active");
                $('.hide-more').html('收起<i class="iconfont iconup"></i>');
            }

            return false;
        })

        // 点击释义导航
        $("body").on("click",".side-nav ul li",function(e){
            isClick = true;
            let nav_item = $(this).attr("data-nav");
            let title_top = $(".title-"+nav_item+"").offset().top;
            $(this).addClass("active").siblings().removeClass("active");
            setTimeout(function(){
                isClick = false;
            },600);
            $('html, body').animate({
                scrollTop: title_top
            }, 500);
        })
        // 点击清除输入的内容
        $(".clear-text").click(function(e){
            // $("#yuanwen").val('').focus();
            // $(".text-length").text("0/2000").removeAttr("style");
            var elem = document.getElementById("yuanwen");
            // elem.addEventListener('input','', false);
            elem.value = '';
            var event = new InputEvent('input');
            elem.dispatchEvent(event);
            _this.emptyContentInit();
            e.stopPropagation();
        })
        // 点击历史记录
        $("body").on("click",".history-item",function(){
            let item = $(this).text();
            // $("#yuanwen").val(item).focus();
            var elem = document.getElementById("yuanwen");
            // elem.addEventListener('input', console.log, false);
            elem.value = item;
            var event = new InputEvent('input');
            elem.dispatchEvent(event);

            let current_act = $(".lan-left .often-lan.active").attr("data-drt");
            let current_act2 = $(".lan-right .often-lan.active").attr("data-drt");

            _this.conTextDrt1(current_act);
            _this.conTextDrt2(current_act2);
        })

        // 监听页面滚动
        document.addEventListener('scroll', function(){
            let scrollH = $(document).scrollTop();
            if (scrollH > 517) {
                let left_pos = (document.body.offsetWidth - 1080)/2;
                $(".side-nav-box").css({
                    "position":"fixed",
                    "top":"0px",
                    "left":left_pos
                })
            }else{
                $(".side-nav-box").removeAttr("style","");
            }
            if (!isClick) {
                if ($(".title-shiyi").is(":visible")) {
                    var top1 = $(".title-shiyi").offset().top - 100;
                }
                if ($(".title-yingying").is(":visible")) {
                    var top2 = $(".title-yingying").offset().top - 100;
                }
                if ($(".title-tongyi").is(":visible")) {
                    var top3 = $(".title-tongyi").offset().top - 100;
                }
                if ($(".title-yongli").is(":visible")) {
                    var top4 = $(".title-yongli").offset().top - 100;
                }
                
                if (scrollH > top1 && scrollH < top1) {
                    $(".side-nav li:nth-child(1)").addClass("active").siblings().removeClass("active");
                }else if(scrollH > top2 && scrollH < top3) {
                    $(".side-nav li:nth-child(2)").addClass("active").siblings().removeClass("active");
                }else if(scrollH > top3 && scrollH < top4) {
                    $(".side-nav li:nth-child(3)").addClass("active").siblings().removeClass("active");
                }else if(scrollH > top4) {
                    $(".side-nav li:nth-child(4)").addClass("active").siblings().removeClass("active");
                }else{
                    $(".side-nav li:nth-child(1)").addClass("active").siblings().removeClass("active");
                }
            }
        })

        // 点击body隐藏语言框
        $("body").click(function(e){
            var div_top = $(".total-lan-box");
            var common_box = $('.common-shadow-bg');
            if(!common_box.is(e.target) && common_box.has(e.target).length === 0){
                if (!div_top.is(e.target) && div_top.has(e.target).length === 0) {
                    _this.hideLanBox();
                }
                e.stopPropagation();
            }
            /*if ($(e.target).find(".total-lan-box").length !== 0) {
                _this.hideLanBox();
            }*/
        })
        
        // 人工校对
        $("body").on("click",".human_proof",function(){
            _comMeds.countLink(1008,100);
            let str = $(".lan-left .often-lan.active").text()
            let str1 = str.indexOf('检测到') != -1?_this.data.checkText:str
            let str2 = $(".lan-right .often-lan.active").text()
            let yuanwen = $("#yuanwen").val().trim();
            let yiwen = $("#yiwen").text().trim();
            // sessionStorage.setItem('proofreading_originalContent',yuanwen)
            // sessionStorage.setItem('proofreading_translationContent',yiwen)
            location.href = "/trans/humanTrans/transactionOrder/proofreading.html?language="+ str1 +"-"+ str2 +""
        })
        $('body').on('click', '.global-coupon .coupon-box .coupon-btn', function(){
            const type = $('.global-coupon .coupon-box .coupon-btn').data("activity")
            const index = $('.global-coupon .coupon-box .coupon-btn').data("index")
            let payObj = {}
            if(type == 1) {
              // 打折 会员套餐
              payObj = {
                payTab: 1,
                payIndex: 0,
              }
            } else if(type == 2) {
              // 买赠 特惠套餐
              payObj = {
                payTab: 4,
                payIndex: index,
              }
            } else {
              // 无门槛 1.会员定位特惠套餐or会员包月套餐
              const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
              const isVip = userInfo.memberStatus?.memberType?.memberType !== 'normal'
              if(isVip) {
                payObj = {
                  payTab: 4,
                  payIndex: 0,
                }
              } else {
                payObj = {
                  payTab: 1,
                  payIndex: 0,
                }
              }
            }
            _allPayBox.payBox(payObj)
          })
    },

    // 是否可以人工校对
    checkLanguageStatusFuc() {
        let str = $(".lan-left .often-lan.active").text()
        let subData = {
            fromLanguage: str.indexOf('检测到') != -1?this.data.checkText:str,
            toLanguage: $(".lan-right .often-lan.active").text()
        }
        _humanTrans.apicheckLanguageStatus(subData, res => {
            if(res == 0) {
                $('.human_proof').show()
            }else {
                $('.human_proof').hide()
            }
        })
    },
    // 点击语言操作
    lanOperate (code, lanName, drt, type) {
        console.log(code, lanName, drt, type,'lanOperate');
        let _this = this;
        let lan_item = {
            languageCode:code,
            languageName:lanName,
            direction:drt
        };
        let yuanwen = $("#yuanwen").val();
        let from_is_the_same = 0, to_is_the_same = 0;
        

        if (type == '1') {
            // 原文

            // * 判断是否和译文相同'
            if(code == $(".lan-right li.active").attr("data-lan")) {
                // 对调
                $(".toggle-lan").click()
                return
            }
            // _this.setAutoLan(1);
            // 设置链接语言
            _this.getTranParams(type,code);
            _this.data.fromLan = code;
            console.log(_this.data.fromLan,'fromLan');
            let oftenUseFrom = JSON.parse(localStorage.getItem("oftenUseFrom"));

            // 弹窗所选语言和常用相同
            // $.each($(".lan-left li"),function(i,item){
            //     let lan = $(item).attr("data-lan");
            //     if (code === lan) {
            //         from_is_the_same++;
            //         $(item).click();
            //     }
            // })
            
            // 弹窗中所选语言和常用不相同
            if (from_is_the_same === 0) {
                let new_arr = _this.changeArrList(oftenUseFrom,lan_item);
                localStorage.setItem("oftenUseFrom",JSON.stringify(new_arr));
                console.log(new_arr,'oftenUseFrom');
                _this.initOftenUseLan(1);
                // $(".lan-left li:nth-child(2)").text(lanName).attr("data-lan",code).addClass("active").siblings().removeClass("active");
                $(".lan-left li:nth-child(1)").click();
            }
        }else{
            // 译文
            // * 判断是否和原文相同
            if(code == $(".lan-left li.active").attr("data-lan")) {
                // 对调
                $(".toggle-lan").click()
                return
            }
            // 设置链接语言
             _this.getTranParams(type,code);
            _this.data.toLan = code;
            let oftenUseTo = JSON.parse(localStorage.getItem("oftenUseTo"));

            $.each($(".lan-right li"),function(i,item){
                let lan = $(item).attr("data-lan");
                if (code === lan) {
                    to_is_the_same++;
                    $(item).click();
                }
            })

            if (to_is_the_same === 0) {
                let new_arr = _this.changeArrList(oftenUseTo,lan_item);
                localStorage.setItem("oftenUseTo",JSON.stringify(new_arr));
                _this.initOftenUseLan(2);
                $(".lan-right li:nth-child(1)").click();
            }   
        }
        _this.hideLanBox();
        
        // if (yuanwen) {
        //     _this.useWhichTran(_this.data.fromLan,_this.data.toLan,yuanwen);
        // }
    },
    // 点击常用语言操作
    ofenLangClick(lan_text, fromLan,drt, type){
        let _this = this;
        if (type == '1') {
            _this.conTextDrt1(drt);

            let from = fromLan;
            _this.data.fromLan = from;
            if (from !== 'auto') {
                // _this.setAutoLan(1);

                if (from == $(".lan-right li.active").attr("data-lan")) {
                    // 原文选择和译文相同
                    _this.setTheSameLan(1);
                }else{
                    let lan_item = {
                        languageCode: from,
                        languageName: lan_text,
                        direction:drt
                    };
                    let oftenUseFrom = JSON.parse(localStorage.getItem("oftenUseFrom"));
                    let new_arr = _this.changeArrList(oftenUseFrom,lan_item);
                    localStorage.setItem("oftenUseFrom",JSON.stringify(new_arr));
                }
            }

            // 设置链接语言
            _this.getTranParams(type,from);
        }else{
            _this.conTextDrt2(drt);

            let to = fromLan;
            _this.data.toLan = to;
            if (to == $(".lan-left li.active").attr("data-lan")) {
                // 原文选择和译文相同
                _this.setTheSameLan(2);
            }else{
               let lan_item = {
                   languageCode: to,
                   languageName: lan_text,
                   direction:drt
               };
               let oftenUseTo = JSON.parse(localStorage.getItem("oftenUseTo"));
               let new_arr = _this.changeArrList(oftenUseTo,lan_item);
               localStorage.setItem("oftenUseTo",JSON.stringify(new_arr)); 
            }

            // 设置链接语言
            _this.getTranParams(type,to);
        }

        let yuanwen = $("#yuanwen").val();
        if (yuanwen) {
            _this.useWhichTran(_this.data.fromLan,_this.data.toLan,yuanwen);
        }
    },
    // 获取语言
    getLanguageOptions : function() {
        var _this = this;
        _tran.getLanguage({},function(res){
            let fromList = res.fromList;
            let lan_str = '';
            _this.data.totalLan = fromList;
            _this.data.toLang = res.toList;

            // 初始化常用语言
            _this.initOftenUseLan(3);

            $.each(fromList,function(i,item){
                _this.getLanList(item);
            })
        },function(res){
            $(".lan-table").hide();
            return;
        })
    },
    // 百度翻译
    baiduTran(){
        var appid = '20200611000492391';
        var key = 'sDIFUGqNKJRu9hLQHWkE';
        var salt = (new Date).getTime();
        var query = 'apple';
        // 多个query可以用\n连接  如 query='apple\norange\nbanana\npear'
        var from = 'en';
        var to = 'zh';
        var str1 = appid + query + salt +key;
        var sign = md5(str1);
        $.ajax({
            url: 'https://fanyi.baidu.com/v2transapi',
            type: 'get',
            dataType: 'jsonp',
            data: {
                q: query,
                from: from,
                to: to,
                sign: sign,
                token: 'd0fa0c0d6cc47cc6db663f995baa2fd7',
                simple_means_flag: 3,
                transtype: 'realtime'
            },
            success: function (data) {
                console.log(data);
            } 
        });
    },
    // 谷歌翻译
    googleTran(from,to,text){
        let _this = this;
        _this.textTran(from,to.split('-')[0],text);
        return false;

        // $.ajax({
        //     // url: 'https://translate.google.cn/translate_a/single',
        //     url:`https://translate.googleapis.com/translate_a/single?client=webapp&sl=${from}&tl=${to}&hl=zh-CN&dt=at&dt=bd&dt=ex&dt=ld&dt=md&dt=qca&dt=rw&dt=rm&dt=sos&dt=ss&dt=t&source=bh&ssel=0&tsel=0&xid=45662847&kc=1&tk=${res}`,
        //     type: 'post',
        //     dataType: 'json',
        //     async: false,
        //     contentType:'application/x-www-form-urlencoded',
        //     data:{
        //         q:query
        //     },
        //     success: function (data) {
        //         // 存储翻译历史记录
        //         _this.setHistory(query);

        //         if(data.length > 0){
        //             let text = '',type = '', shili_str = '', liju_str = '', jinyi_str = '', ciyu_str = '', isLanError = false, isContent = 0;
        //             let isActive = false;
        //             // 显示译文
        //             _this.setYiContent(data[0]);
        //             $(".shiyi .left-nav").empty();

        //             // 检测语言判断
        //             if (data[8]) {
        //                 let check_lan = data[8][0];
        //                 if (from == 'auto') {
        //                     $.each(googleLans,function(i,item){
        //                         if (item.languageCode == check_lan) {
        //                             _this.data.checkText = item.languageName;
        //                         }else{
        //                             if (check_lan == 'zh-CN') {
        //                                 _this.data.checkText = '中文';
        //                             }
        //                         }
        //                     })
                            
        //                     _this.setAutoLan(2,_this.data.checkText);
        //                 }else{
        //                     // 判断原语言是否和谷歌返回的语言编码相同
        //                     if (from != check_lan && $("#yuanwen").val().length > 5) {
        //                         $.each(googleLans,function(i,item){
        //                             if (item.languageCode == check_lan) {
        //                                 _this.data.checkText = item.languageName;
        //                                 isLanError = true;
        //                                 $(".error-lan-box p .true-lan").text(_this.data.checkText);
        //                                 _this.showBottomCard(1);
        //                             }
        //                         })
        //                     }else{
        //                         // 选的语言和检验的语言相同
        //                         isLanError = false;
        //                     }
        //                 }
        //             }

        //             // 显示词性、单词等
        //             if (!isLanError) {
        //                 // 单词释义
        //                 if (data[1]) {
        //                     isContent ++;
        //                     let active_str = '';
        //                     if (!isActive) {
        //                         isActive = true;
        //                         active_str = 'active';
        //                     }
                            
        //                     $.each(data[1],(i,item)=>{
        //                         shili_str += _this.wordStr(item);
        //                     })
        //                     shili_str = '<h3 class="title-shiyi title">简明释义</h3>' + shili_str;

        //                     $(".shiyi .shiyi-content").empty().append(shili_str).show();
        //                     $(".shiyi .left-nav").append(`<li class='${active_str}' data-nav='shiyi'>简明释义</li>`);
        //                 }else{
        //                     $(".shiyi-content").empty().hide();
        //                 }

        //                 // 英英释义
        //                 if(data[12]){
        //                     isContent++;
        //                     let active_str = '';
        //                     $.each(data[12],(i,item)=>{
        //                        liju_str += `<p class="what-word"><span class="iconfont iconshouqimingxi triangle"></span>${item[0]}</p>`+_this.sentenceStr(item[1]);
        //                     })

        //                     liju_str = '<h3 class="title title-yingying">英英释义</h3>' + liju_str;
                            
        //                     if (!isActive) {
        //                         isActive = true;
        //                         active_str = 'active';
        //                     }
        //                     $(".shiyi .liju-content").empty().append(liju_str).show();
        //                     $(".shiyi .left-nav").append(`<li class='${active_str}' data-nav='yingying'>英英释义</li>`);
        //                 }else{
        //                     $(".liju-content").empty().hide();
        //                 }
        //                 // 同义释义
        //                 if (data[11]) {
        //                     isContent++;
        //                     let active_str = '';
        //                     $.each(data[11],(i,item)=>{
        //                        jinyi_str += `<p class="what-word"><span class="iconfont iconshouqimingxi triangle"></span>${item[0]}</p>`+_this.sameWordStr(item[1]);
        //                     })
        //                     jinyi_str = '<h3 class="title title-tongyi">同义解析</h3>' + jinyi_str;
        //                     if (!isActive) {
        //                         isActive = true;
        //                         active_str = 'active';
        //                     }
        //                     $(".shiyi .jinyi-content").empty().append(jinyi_str).show();
        //                     $(".shiyi .left-nav").append(`<li class='${active_str}' data-nav='tongyi'>同义解析</li>`);
        //                 }else{
        //                     $(".jinyi-content").empty().hide();
        //                 }

        //                 // 词语用例
        //                 if (data[13]) {
        //                     isContent++;
        //                     let active_str = '';
        //                     let item_length = 0;
        //                     $.each(data[13],(i,item)=>{
        //                        ciyu_str += _this.exampleStr(item);
        //                        item_length = item.length;
        //                     })
        //                     ciyu_str = '<h3 class="title title-yongli">词语用例</h3>' + ciyu_str;
        //                     if (!isActive) {
        //                         isActive = true;
        //                         active_str = 'active';
        //                     }
        //                     $(".shiyi .ciyu-info").empty().append(ciyu_str);
        //                     $(".ciyu-content").show();
        //                     $(".shiyi .left-nav").append(`<li class='${active_str}' data-nav='yongli'>词语用例</li>`);
        //                     if (item_length > 8) {
        //                         if ($(".hide-more").length === 0) {
        //                             // let shouqi = `<div class="hide-more">收起<i class="iconfont iconup"></i></div>`;
        //                             // $(".ciyu-content").append(shouqi);
        //                             let shouqi = `<div class="hide-more">展开<i class="iconfont icondown"></i></div>`;
        //                             $(".ciyu-content").append(shouqi);
        //                         }
        //                     }else{
        //                         $(".hide-more").remove();
        //                     }
        //                 }else{
        //                     $(".ciyu-info").empty();
        //                      $(".ciyu-content").hide();
        //                 }

        //                 if (isContent === 0) {
        //                     _this.showBottomCard();
        //                 }else{
        //                     _this.showBottomCard(3);
        //                 }
        //             }
        //         }else{
        //             $("#yiwen").html('');
        //         }
        //     } 
        // });
    },
    // 文本翻译
    textTran(from,to,text){
        let _this = this;
        var isLanError = false;
        let subData = {
            from:from,
            to:to,
            src:text,
            t:this.TK(text)
        };
        _tran.textTran(subData,function(res){
            // 存储翻译历史记录
            console.log(text,'history');
            _this.setHistory(text);

            if (res.dst.length > 0) {
                $("#yiwen").html(res.dst);
            }else{
                $("#yiwen").html('');
            }
            // 存储译文
            // sessionStorage.setItem('yiwen',$("#yiwen").text().trim());
            // 存储原文
            // sessionStorage.setItem('yuanwen',$("#yuanwen").val().trim());
            let total_lan = _this.data.totalLan;
            let res_from = res.from;
            if (from == 'auto') {
                $.each(total_lan,function(i,item){
                    if (item.languageCode == res.detectLan) {
                        _this.data.checkText = item.languageName;
                    }
                })
                _this.setAutoLan(2,_this.data.checkText);
            }else{
                // 判断原语言是否和谷歌返回的语言编码相同
                if (from != res_from && $("#yuanwen").val().length > 5) {
                    $.each(total_lan,function(i,item){
                        if (item.languageCode == res_from) {
                            _this.data.checkText = item.languageName;
                            isLanError = true;
                            $(".error-lan-box p .true-lan").text(_this.data.checkText);
                            _this.showBottomCard(1);
                        }
                    })
                }else{
                    // 选的语言和检验的语言相同
                    isLanError = false;
                }
            }
            // _this.checkLanguageStatusFuc()
        },function(res){
            $("#yiwen").html('');
            console.log(res);
            // _this.checkLanguageStatusFuc()
        })
    },
    // 谷歌翻译检测语言
    googleTranTestLan(from,to,text){
        let _this = this;
        var query = text;
        var res = this.TK(query);

        $.ajax({
            // url: 'https://translate.google.cn/translate_a/single',
            url:`https://translate.googleapis.com/translate_a/t?client=webapp&sl=${from}&tl=${to}&hl=zh-CN&dt=at&dt=bd&dt=ex&dt=ld&dt=md&dt=qca&dt=rw&dt=rm&dt=sos&dt=ss&dt=t&source=bh&ssel=0&tsel=0&xid=45662847&kc=1&tk=${res}`,
            type: 'post',
            dataType: 'json',
            contentType:'application/x-www-form-urlencoded',
            data:{
                q:query
            },
            success: function (data) {
                console.log(data);
            } 
        });
    },
    // 签名加密算法
    TK(a) {
        var k = "";
        var b = 20211230;
        var b1 = 3278921072;
        // var b = 406644;
        // var b1 = 3293161072;

        var jd = ".";
        var $b = "+-a^+6";
        var Zb = "+-3^+b+-f";

        for (var e = [], f = 0, g = 0; g < a.length; g++) {
            var m = a.charCodeAt(g);
            128 > m ? e[f++] = m : (2048 > m ? e[f++] = m >> 6 | 192 : (55296 == (m & 64512) && g + 1 < a.length && 56320 == (a.charCodeAt(g + 1) & 64512) ? (m = 65536 + ((m & 1023) << 10) + (a.charCodeAt(++g) & 1023),
                e[f++] = m >> 18 | 240,
                e[f++] = m >> 12 & 63 | 128) : e[f++] = m >> 12 | 224,
                e[f++] = m >> 6 & 63 | 128),
                e[f++] = m & 63 | 128)
        }
        a = b;
        for (f = 0; f < e.length; f++) a += e[f],
            a = this.RL(a, $b);
        a = this.RL(a, Zb);
        a ^= b1 || 0;
        0 > a && (a = (a & 2147483647) + 2147483648);
        a %= 1E6;
        return a.toString() + jd + (a ^ b)
    },
    RL(a, b) {
        var t = "a";
        var Yb = "+";
        for (var c = 0; c < b.length - 2; c += 3) {
            var d = b.charAt(c + 2),
                d = d >= t ? d.charCodeAt(0) - 87 : Number(d),
                d = b.charAt(c + 1) == Yb ? a >>> d: a << d;
            a = b.charAt(c) == Yb ? a + d & 4294967295 : a ^ d
        }
        return a
    },
    // 传入数组，返回一个包含词性和内容的函数
    wordStr(data){
        let word_str = '',text = '';
        word_str = this.whatWord(data[0]);

        $.each(data[2],(i,item)=>{
            text += `<p>${item[0]}: <span class="grey">${item[1].join('；')}</span></p>`;
        })
        return word_str+text;
    },
    // 根据英文，判断是什么词
    whatWord(word){
        var type = '';
        return '<p class="what-word"><span class="iconfont iconshouqimingxi triangle"></span>'+word+'</p>';
    },
    // 传入数组，返回句子字符串
    sentenceStr(data){
        let str = '';
        $.each(data,function(i,item){
            str += `<p>${i+1}.&nbsp;&nbsp;${item[0]}<br/><span class="tip-str">${item[2]?item[2]:''}</span></p>`;
        })
        return str;
    },
    // 传如数组，返回同义词
    sameWordStr(data){
        let str = '';
        $.each(data,function(i,item){
            str += `<span>${item[0].join("</span><span>")}</span>`;
        })
        return str;
    },
    // 传入数组，返回例句
    exampleStr(data){
        let str = '';
        $.each(data,function(i,item){
            str += `<p><span class="index-item">${i+1}.</span> ${item[0]}</p>`;
        })
        return str;
    },
    // 返回译文拼接文本
    setYiContent(data){
        let yi_str = '';
        // 显示译文
        $.each(data,function(i,item){
            if (item[0]) {
                yi_str += item[0];
                $("#yiwen").html(yi_str);
            }
        })
    },
    // 设置历史记录
    setHistory(text){
        if (text) {
            // 存储翻译历史记录
            let new_arr = this.data.historyArr;
            $.each(new_arr,function(i,item){
                if (item == text) {
                    new_arr.splice(i,1);
                }
            })
            // 最多存储20项
            if (new_arr.length >= 20) {
                new_arr.pop();
            }
            new_arr.unshift(text);
            localStorage.setItem("tranHistory",JSON.stringify(new_arr)); 
            this.historyItem();
        }
    },
    // 显示历史记录列表
    historyItem(){
        let new_arr = this.data.historyArr;
        console.log(new_arr,'historyItem');
        if (new_arr.length > 0) {
            $(".empty-content").hide();
            $(".history-div .clear-all").show();
            let item_str = '';
            $.each(new_arr,(i,item)=>{
                item_str += '<span class="history-item">'+item+'</span>';
            })
            $(".history-content").empty().append(item_str).show();
        }else{
            $(".empty-content").show();
            $(".history-div .clear-all").hide();
        }
    },
    // 初始化弹窗语言列表
    lanInit : function() {
        var letter,item_str = '',index_str = '';
        for(var i=0;i<26;i++){
            letter = String.fromCharCode(97+i);
            item_str += `<div class="letter-block letter-block-${letter}">
                            <p class="letter-title">${letter.toUpperCase()}</p>
                            <div class="letter-content"></div>
                        </div>`;
            index_str += `<li class="letter-index letter-index-${letter}">${letter.toUpperCase()}</li>`;
        }
        $(".lan-table").append(item_str);
        $(".letter-index-ol").append(index_str);
        this.getLanguageOptions();
    },
    // 初始化常用语言
    initOftenUseLan(type){
        let _this = this;
        let tl = _comMeds.getUrlParam("tl");
        let sl = _comMeds.getUrlParam("sl");
        let text = _comMeds.getUrlParam("text");
        console.log(tl,sl,'initOftenUseLan',type);
        if (type === 1 || type === 3) {
            let source_item = _this.getLanObj(sl);

            if (localStorage.getItem("oftenUseFrom")) {
                let lan = JSON.parse(localStorage.getItem("oftenUseFrom"));
                if (sl) {
                    $.each(lan,(i,item)=>{
                        $(".lan-left li:nth-child("+(i+1)+")").text(item.languageName);
                        $(".lan-left li:nth-child("+(i+1)+")").attr("data-lan",item.languageCode);
                        $(".lan-left li:nth-child("+(i+1)+")").attr("data-drt",item.direction);
                        if (i === 0) {
                            _this.data.fromLan = item.languageCode;
                            _this.conTextDrt1(item.direction);
                        }
                    })
                    $(".lan-left li:nth-child(1)").addClass("active");
                    if (sl !== 'auto') {
                        lan = _this.changeArrList(lan,source_item);
                    }else{
                        _this.data.fromLan = 'auto';
                    }
                }else{
                    $.each(lan,(i,item)=>{
                        $(".lan-left li:nth-child("+(i+1)+")").text(item.languageName);
                        $(".lan-left li:nth-child("+(i+1)+")").attr("data-lan",item.languageCode);
                        $(".lan-left li:nth-child("+(i+1)+")").attr("data-drt",item.direction);
                        if (i === 0) {
                            _this.data.fromLan = item.languageCode;
                            _this.conTextDrt1(item.direction);
                        }
                    })
                    $(".lan-left li:nth-child(1)").addClass("active");
                    _this.conTextDrt1(0);
                }
            }else{
                let index = 1,isTheSame = false;
                let lanArr = [
                    {languageCode:'auto',languageName:'自动检测',direction:0},
                    {languageCode:'zh',languageName:'中文',direction:0},
                    {languageCode:'jp',languageName:'日语',direction:0}
                ];
                if (sl) {
                    $.each(lanArr,(i,item)=>{
                        if (item.languageCode == source_item.languageCode) {
                            index = i + 1;
                            isTheSame = true;
                        }
                    })

                    // 初始化语言没有重复的
                    if (!isTheSame) {
                        lanArr = [
                            source_item,
                            {languageCode:'zh',languageName:'中文',direction:0},
                            {languageCode:'jp',languageName:'日语',direction:0}
                        ];
                        $(".lan-left li:nth-child("+index+")").text(source_item.languageName).attr("data-lan",source_item.languageCode);
                        $(".lan-left li:nth-child("+index+")").attr("data-drt",source_item.direction);
                        $(".lan-left li:nth-child("+index+")").addClass("active");
                    }else{
                        $(".lan-left li:nth-child("+index+")").addClass("active");
                    }
                }else{
                    $(".lan-left li:nth-child(1)").addClass("active");
                }

                localStorage.setItem("oftenUseFrom",JSON.stringify(lanArr));
            }
        }

        if (type === 2 || type === 3) {
            let to_item = {};
            if (tl != 'auto') {
                to_item = _this.getLanObj(tl);
            }

            if (localStorage.getItem("oftenUseTo")) {
                let lan = JSON.parse(localStorage.getItem("oftenUseTo"));
                if (tl && !this.isNullObj(to_item)) {
                    lan = _this.changeArrList(lan,to_item);
                }
                $.each(lan,(i,item)=>{
                    $(".lan-right li:nth-child("+(i+1)+")").text(item.languageName).attr("data-lan",item.languageCode);
                    $(".lan-right li:nth-child("+(i+1)+")").attr("data-drt",item.direction);
                    $(".lan-right li:nth-child(1)").addClass("active");
                    if (i === 0) {
                        _this.data.toLan = item.languageCode;
                        _this.conTextDrt2(item.direction);
                    }
                })
            }else{
                let index = 1,isTheSame = false;
                let lanArr = [
                    {languageCode:'en',languageName:'英语',direction:0},
                    {languageCode:'zh',languageName:'中文',direction:0},
                    {languageCode:'kor',languageName:'韩语',direction:0}
                ];

                // 如果目标语言存在，且不为自动，不是随便输入的字符
                if (tl && tl != 'auto' && !this.isNullObj(to_item)) {
                    $.each(lanArr,(i,item)=>{
                        if (item.languageCode == to_item.languageCode) {
                            index = i + 1;
                            isTheSame = true;
                        }
                    })

                    // 初始化语言没有重复的
                    if (!isTheSame) {
                        lanArr = [
                            to_item,
                            {languageCode:'zh',languageName:'中文',direction:0},
                            {languageCode:'en',languageName:'英语',direction:0}
                        ];
                        $(".lan-right li:nth-child("+index+")").text(to_item.languageName).attr("data-lan",to_item.languageCode);
                        $(".lan-right li:nth-child("+index+")").attr("data-drt",to_item.direction);
                    }
                    $(".lan-right li:nth-child("+index+")").addClass("active");
                }else{
                    $(".lan-right li:nth-child(1)").addClass("active");
                }
               
                localStorage.setItem("oftenUseTo",JSON.stringify(lanArr));
            }
        }

        if (type === 3) {
            if (text) {
                $("#yuanwen").val(text);
                _this.useWhichTran(_this.data.fromLan,_this.data.toLan,text);
            }
        }

        if (tl && sl) {
            this.countLink(sl,tl);
        }
    },
    // 交换语言后初始化语言
    afterChangeLan(){
        let oftenUseFrom = localStorage.getItem("oftenUseFrom");
        let oftenUseTo = localStorage.getItem("oftenUseTo");
        let _this = this;

        if (oftenUseFrom) {
            let lan = JSON.parse(oftenUseFrom);
            $.each(lan,(i,item)=>{
                $(".lan-left li:nth-child("+(i+1)+")").text(item.languageName);
                $(".lan-left li:nth-child("+(i+1)+")").attr("data-lan",item.languageCode);
                $(".lan-left li:nth-child("+(i+1)+")").attr("data-drt",item.direction);
                if (i === 0) {
                    _this.data.fromLan = item.languageCode;
                    _this.conTextDrt1(item.direction);
                }
            })
            $(".lan-left li").removeClass("active");
            $(".lan-left li:nth-child(1)").addClass("active");
        }
        if (oftenUseTo) {
            let lan = JSON.parse(oftenUseTo);
            $.each(lan,(i,item)=>{
                $(".lan-right li:nth-child("+(i+1)+")").text(item.languageName);
                $(".lan-right li:nth-child("+(i+1)+")").attr("data-lan",item.languageCode);
                $(".lan-right li:nth-child("+(i+1)+")").attr("data-drt",item.direction);
                if (i === 0) {
                    _this.data.toLan = item.languageCode;
                    _this.conTextDrt2(item.direction);
                }
            })
            $(".lan-right li").removeClass("active");
            $(".lan-right li:nth-child(1)").addClass("active");
        }
        // 调用翻译
        let yuanwen = $("#yuanwen").val();
        let yiwen = $("#yiwen").text();
        // 判断yiwen是否有span子元素
        if($("#yiwen").has("span").length > 0){
            yiwen = ''
        }
        
        
        // 对换语言调换文本内容并翻译
        if (!yiwen) {
            if (yuanwen) {
                // _this.googleTran(_this.data.fromLan,_this.data.toLan,yuanwen);
                _this.useWhichTran(_this.data.fromLan,_this.data.toLan,yuanwen);
            }
        }else{
            $("#yuanwen").val(yiwen);
            _this.useWhichTran(_this.data.fromLan,_this.data.toLan,yiwen);
        } 
    },
    // 获取请求到的语言
    getLanList(item){
        let first_letter = item.firstLetter;
        let isVip = '';
        if(item.vip){
            isVip = 'isVip'
        }
        let lan_item = `<span class="lang-item lang-style ${isVip}" data-code="${item.languageCode}" data-drt="${item.direction}" data-vip="${item.vip}">${item.languageName}</span>`;
        $(".letter-block-"+first_letter+"").show().find(".letter-content").append(lan_item);
        $(".letter-index-"+first_letter+"").show();
    },
    // 调整数组顺序
    changeArrList(arr,addItem){
        let code = addItem.languageCode;
        let same_flag = 0;
        $.each(arr,(i,item)=>{
            if (item.languageCode === code) {
                arr.splice(i,1);
                arr.unshift(addItem);
                same_flag++;
            }
        })
        if (same_flag === 0) {
            arr.pop();
            arr.unshift(addItem);
        }

        return arr;
    },
    // 隐藏语言选择框
    hideLanBox(){
        $(".total-lan-box").hide();
        $('.lang-box .icondown').removeClass('active')
        $(".top-lan-box .wrap").removeClass("active");
        $(".show-more-lan").removeClass("active");
    },
    // 是否首次进入文本翻译页面
    isFristCome(){
        if (!localStorage.getItem("isFristComeText")) {
            $(".tip-box").show();
            localStorage.setItem("isFristComeText",'1');
        }
    },
    // 设置textarea高度
    setTextAreaHeight(elem, extra, maxHeight) {
            extra = extra || 0;
            var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window,
            isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera'),
                    addEvent = function (type, callback) {
                            elem.addEventListener ?
                                    elem.addEventListener(type, callback, false) :
                                    elem.attachEvent('on' + type, callback);
                    },
                    getStyle = elem.currentStyle ? function (name) {
                            var val = elem.currentStyle[name];
     
                            if (name === 'height' && val.search(/px/i) !== 1) {
                                    var rect = elem.getBoundingClientRect();
                                    return rect.bottom - rect.top -
                                            parseFloat(getStyle('paddingTop')) -
                                            parseFloat(getStyle('paddingBottom')) + 'px';        
                            };
     
                            return val;
                    } : function (name) {
                                    return getComputedStyle(elem, null)[name];
                    },
                    minHeight = parseFloat(getStyle('height'));
     
            var change = function () {
                    var scrollTop, height,
                            padding = 0,
                            style = elem.style;
     
                    if (elem._length === elem.value.length) return;
                    elem._length = elem.value.length;
     
                    if (!isFirefox && !isOpera) {
                            padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
                    };
                    if (elem._length > 100) {
                        elem.style.fontSize = '14px';
                        document.getElementById("yiwen").style.fontSize = '14px';
                    }else{
                        elem.style.fontSize = '18px';
                        document.getElementById("yiwen").style.fontSize = '18px';
                    }
                    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                    elem.style.height = minHeight + 'px';
                    $('.yiwen').css('height',minHeight + 'px');
                    if (elem.scrollHeight > minHeight) {
                            if (maxHeight && elem.scrollHeight > maxHeight) {
                                    height = maxHeight - padding;
                                    style.overflowY = 'auto';
                            } else {
                                    height = elem.scrollHeight - padding;
                                    style.overflowY = 'hidden';
                            };
                            style.height = height + extra + 'px';
                            $('.yiwen').css('height',height + extra + 'px');
                            scrollTop += parseInt(style.height) - elem.currHeight;
                            document.body.scrollTop = scrollTop;
                            document.documentElement.scrollTop = scrollTop;
                            elem.currHeight = parseInt(style.height);
                    };
            };
     
            addEvent('propertychange', change);
            addEvent('input', change);
            addEvent('focus', change);
            change();
    },
    // 决定调用哪个翻译引擎
    useWhichTran(from_lan,to_lan,lan){
        _comMeds.countLink(335,81);
        let _this = this;
        console.log("对照的语言：",from_lan,to_lan)
        let plat = getPlatformList('pc',from_lan,to_lan);
        console.log(plat);
        // vip语言限制
        $.each(_this.data.totalLan, function(i, item){
            if(item.vip == 1 && (item.languageCode == from_lan || item.languageCode == to_lan)){
                if(_comMeds.isLogin()){
                    if(JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
                        _this.vipPayTipBox(function(){
                            if (plat) {
                                _this.textTran(from_lan,to_lan,lan);
                                return false
                            }else{  
                                _this.textTran(from_lan,to_lan,lan);
                                $(".error-lan-box").hide();
                            }
                        });
                        return false;
                    } else {
                        if(item.languageCode == from_lan || item.languageCode == to_lan){
                            if (plat) {
                                _this.textTran(from_lan,to_lan,lan);
                                return false
                            }else{  
                                // 都不支持，调用小牛翻译
                                _this.textTran(from_lan,to_lan,lan);
                                $(".error-lan-box").hide();
                            }
                            return false
                        } 
                    }
                } else {
                    _comMeds.doLogin();
                }
            } else {
                if(item.languageCode == from_lan || item.languageCode == to_lan){
                    if (plat) {
                        _this.textTran(from_lan,to_lan,lan);
                        return false
                    }else{  
                        // 都不支持，调用小牛翻译
                        _this.textTran(from_lan,to_lan,lan);
                        $(".error-lan-box").hide();
                    }
                    return false
                } 
            }
        })
       
    },
    // 设置自动检测的语言
    setAutoLan(type,text){
        console.log(type, text,'setAutoLan');
        // type为1恢复为自动检测
        if (type == 1) {
            this.data.checkText = '';
            $(".lan-left .often-lan.active").text("自动检测");
            
        }else if (type == 2) {
            $(".lan-left .often-lan.active").text("检测到"+text);
            $(".lan-left .often-lan.active").attr("data-lan",'auto');
            // if ($(".auto-tran-option").hasClass("active")) {
            //     $(".auto-tran-option").text("检测到"+text);
            //     // $(".auto-tran-option").text(text);
            // }else{
            //     this.data.checkText = '';
            //     $(".auto-tran-option").text("自动检测");
            // }
        }
    },
    // 当所选语言和自动检测的不同时
    showBottomCard(type){
        // 1:显示错误语言提示，2:显示历史记录，3:显示释义提示框
        if (type == 1) {
            $(".history-div").hide();
            $(".shiyi").hide();
            $(".error-lan-box").show();
        }else if(type == 2){
            $(".error-lan-box").hide();
            $(".shiyi").hide();
            $(".history-div").show();
        }else if(type == 3){
            $(".error-lan-box").hide();
            $(".history-div").hide();
            $(".shiyi").show();
        }else{
            $(".error-lan-box").hide();
            $(".history-div").hide();
            $(".shiyi").hide();
        }
    },
    // 如果所选语言重复时，设置
    setTheSameLan(type){
        if (type === 1) {
            let index = $(".lan-right li.active").index();
            if (index === 0) {
                $(".lan-right li:nth-child(2)").click();
            }else{
                $(".lan-right li:nth-child(1)").click();
            }
        }else if(type === 2){
            let index = $(".lan-left li.active").index();
            $(".lan-left li:nth-child(1)").click();
        }
    },
    // 原文为空时初始化界面
    emptyContentInit(){
        $('#yiwen').html('<span>译文</span>')
        $(".copy-text, .human_proof").hide();
        $(".shiyi").hide();
        $(".error-lan-box").hide();
        $(".history-div").show();
        console.log('显示历史记录');
        // 存储译文
        // sessionStorage.setItem('yiwen','');
        // 存储原文
        // sessionStorage.setItem('yuanwen','');
        // this.setAutoLan(1);
    },
    // 控制输入框文本显示方向
    conTextDrt1(type1){
        if (type1 == '0') {
            $(".yuanwen-box").removeAttr("style");
            $("#yuanwen").css({
                "direction":"ltr"
            })
        }else if(type1 == '1'){
            $(".yuanwen-box").removeAttr("style");
            $("#yuanwen").css({
                "direction":"rtl"
            })
        }else if(type1 == '2'){
            $(".yuanwen-box").css({
                "writing-mode":"vertical-lr"
            })
            $("#yuanwen").css({
                "display":"table-cell",
                "fontFamily":"Menksoft2012",
                "direction":"ltr"
            })
        }else if(type1 == '3'){
            $(".yuanwen-box").css({
                "writing-mode":"vertical-rl"
            })
            $("#yuanwen").css({
                "display":"table-cell",
                "fontFamily":"Menksoft2012",
                "direction":"ltr"
            })
        }else{
            $(".yuanwen-box").removeAttr("style");
            $("#yuanwen").css({
                "direction":"ltr"
            })
        }
    },
    // 设置译文方向
    conTextDrt2(type2){
        if (type2 == '0') {
            $("#yiwen").css({
                "writing-mode":'',
                "direction":"ltr"
            })
        }else if(type2 == '1'){
            $("#yiwen").css({
                "writing-mode":'',
                "direction":"rtl"
            })
        }else if(type2 == '2'){
            $("#yiwen").css({
                "writing-mode":"vertical-lr",
                "fontFamily":"Menksoft2012",
                "direction":"ltr"
            })
        }else if(type2 == '3'){
            $("#yiwen").css({
                "writing-mode":"vertical-rl",
                "fontFamily":"Menksoft2012",
                "direction":"ltr"
            })
        }else{
            $("#yiwen").css({
                "writing-mode":'',
                "direction":"ltr"
            })
        }
    },
    // 根据语言编码找到那个对象
    getLanObj(lanCode){
        let link_item = {};
        $.each(this.data.totalLan,(i,item)=>{
            if (item.languageCode === lanCode) {
                link_item.languageCode = lanCode;
                link_item.languageName = item.languageName;
                link_item.direction = item.direction;
            }
        })
        return link_item;
    },
    // 获取链接中翻译参数
    getTranParams(type,lanCode){
        let source = _comMeds.getUrlParam("sl");
        let to = _comMeds.getUrlParam("tl");
        let text = _comMeds.getUrlParam("text");

        if (!source) {
            source = this.data.fromLan;
        }
        if (!to) {
            to = this.data.toLan;
        }

        if (type == 1) {
            source = lanCode;
            to = to;
        }else{
            source = source;
            to = lanCode;
        }
        console.log(lanCode,'getTranParams');
        this.changeURLArg(source,to,text);
    },
    // 修改url中的参数
    changeURLArg(sl,tl,text){
        // window.history.replaceState({}, '', `?sl=${sl}&tl=${tl}&text=${text}`);
        window.history.replaceState({}, '', `?sl=${sl}&tl=${tl}`);
    },
    // 判断是否是空对象
    isNullObj(obj){
        for(var i in obj){
            if(obj.hasOwnProperty(i)){
                return false;
            }
        }
        return true;
    },
    countLink(from,to){
        let subData = {
            fromLanguage:from,
            toLanguage:to,
            type:3
        }
        _tran.countMeassageInfo(subData,(res)=>{
            console.log(res);
        },(res)=>{

        })
    }, 
    vipPayTipBox(callback) {
            _comMeds.zgAlert({
                title: '提示',
                content: '<p style="margin:20px auto">成为VIP解锁全部语种</p>',
                yesText: '购买VIP',
                noText: '取消',
                yesFn: _comMeds.throttle(function(e){
                   $('.common-shadow-bg').remove();
                   _comMeds.countLink(139)
                    let payObj = {
                        payTab: 1,
                        payIndex: 0,
                    }
                   _allPayBox.payBox(payObj)
                }),
                noFn: function(e){
                   setTimeout(() => {
                       $('.common-shadow-bg').remove();
                   }, 0)
                   return false;
                },
                closeFn: function(e){
                   setTimeout(() => {
                       $('.common-shadow-bg').remove();
                   }, 0)
                    return false;
                }
            })
    }
}

$(function(){
    page.init();
    _allPayBox.init();
})
